import React, {Component} from 'react';
import {translate}	from 'react-i18next';
import {Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
//import {bin} from 'react-icons-kit/icomoon/bin';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
//import FloatingActionButton from 'material-ui/FloatingActionButton';
import { search } from 'react-icons-kit/icomoon/search';
import { cross } from 'react-icons-kit/icomoon/cross';
//import {print} from 'react-icons-kit/fa/print';
//import { download3 } from 'react-icons-kit/icomoon/download3';

import ModalDetails from './modalDetails';
import ModalStatus from '../../distribution/modalStatus';

const Config = require('../../../config');

class PlasmaticPetition extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.newPetition = this.newPetition.bind(this);
		this.getList = this.getList.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onUpdate = this.onUpdate.bind(this);


		this.state = {
			list:[],
			filter:""
		}
	}

	componentDidMount(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });
			this.getList();
		});
	

		
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product_request/by_me/'+
			sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({list: response});
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newPetition(e){
		e.preventDefault();

		this.props.history.push('/petition_plasmatic_products/new')
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_entries/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    }.bind(this));
	}

	onUpdate(id){
		this.props.history.push('/petition_plasmatic_products/edit/'+id);
	}

	viewDetails(title, id){
		this.modal_details.handleShow(title, id);
	}
	changeStatus(id, status, user){
		this.modal_status.handleShow(id, status, user);
	}

	confirmOrder(id){
		this.props.history.push("/petition_plasmatic_products/confirm/"+id);
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Petición 
					</h5>
				</div>

				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

					<div className="col-xs-12 col-sm-1 col-sm-offset-9">
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							onClick={this.newPetition}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Solicitado a</th>
								<th>Cantidad Total</th>
								<th>Estatus</th>
								<th>Fecha y Hora</th>
								<td></td>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l, i)=>(
								<tr key={i}>
									<td>{l.request.id}</td>
									<td>{l.request_to.name}</td>
									<td></td>
									<td>{l.request.status}</td>
									<td>
										{moment(l.request.date).format('DD/MM/YYYY')+' '}
										{moment(l.request.hour, 'H:mm:ss').format('HH:mm')}
									</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}}
											onClick={this.viewDetails.bind(this,'Pedido de Productos Hemostáticos', l.request.id)}>
											<SvgIcon icon={search} />
										</Button>
										{/*}
										<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
											onClick={(e)=>this.onPrint(l.id, e)}>
											<SvgIcon icon={print} />
										</Button>*/}
										<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
											disabled={(l.status !== 'PENDIENTE')}
											onClick={this.onUpdate.bind(this, l.request.id)}>
											<SvgIcon icon={pencil2} />
										</Button>
										{/*<Button className="btn btn-info btn-xs" title="Descargar" style={{marginRight:"5px"}}
											disabled={l.status !== 'SUMINISTRADO'} 
											onClick={this.confirmOrder.bind(this,l.id)}>
											<SvgIcon icon={download3} />
										</Button>*/}
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											disabled={l.status !== 'ENVIADO'}
											onClick={this.changeStatus.bind(this,l.request.id, l.request.status, l.request.user_request_id)}>
											<SvgIcon icon={cross} />
										</Button>

									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>

				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
				<ModalStatus {...this.props} onSearch={this.getList} onRef={ref => (this.modal_status = ref)}/>
			</div>
		)
	}

}

export default translate('translations')(PlasmaticPetition);